export const generateOperationHours = (startHour: string, endHour: string): string[] => {
  const parseTime = (time: string) => {
    const [hour, minute] = time.split(":").map(Number);
    return hour * 60 + minute; // Convert to total minutes
  };

  const formatTime = (minutes: number) => {
    const hour = Math.floor(minutes / 60);
    const minute = minutes % 60;
    return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
  };

  const startMinutes = parseTime(startHour);
  const endMinutes = parseTime(endHour);
  const endOfDayMinutes = 23 * 60 + 45;

  // An end time earlier than the start means the range runs past midnight:
  // list midnight until the end time first, then the start until the end of the day.
  const ranges: [number, number][] =
    startMinutes <= endMinutes
      ? [[startMinutes, endMinutes]]
      : [
          [0, endMinutes],
          [startMinutes, endOfDayMinutes],
        ];

  const intervals: string[] = [];
  for (const [from, to] of ranges) {
    for (let minutes = from; minutes <= to; minutes += 15) {
      intervals.push(formatTime(minutes));
    }
  }

  return intervals;
};
